import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import RequireAuth from "./components/RouteRequiresLogin";
//import PersistLogin from "./components/PersistLogin";

//components used in admin routes
import Events from "./components/admin/pages/Events";
import EventsForm from "./components/admin/forms/EventsForm";
//import CreateEvent from "./components/admin/events/CreateEvent";
import Users from "./components/admin/pages/Users";
import AddUser from "./components/admin/pages/AddUser";
import CreateEditUser from "./components/admin/forms/UserEditForm";
import Dashboard from "./components/admin/Dashboard";
import Settings from "./components/admin/pages/Settings";
import Finances from "./components/admin/pages/Finances";
import OrderDetail from "./components/admin/pages/OrderDetail";
import Roles from "./components/admin/pages/Roles";
import RoleEdit from "./components/admin/pages/RoleEdit";
import Certifications from "./components/admin/pages/Certifications";
import CertificationEdit from "./components/admin/pages/CertificationEdit";
import EventCheckin from "./components/admin/pages/EventCheckin";
import EventCheckinDetail from "./components/admin/pages/EventCheckinDetail";
import UserCheckin from "./components/admin/pages/UserCheckin";
import Reporting from "./components/admin/pages/Reporting";
import AddReport from "./components/admin/pages/AddReport";
import DynamicReportRunner from "./components/admin/pages/reports/DynamicReportRunner";
import RevenueReport from "./components/admin/pages/reports/RevenueReport";
import OutstandingPaymentsReport from "./components/admin/pages/reports/OutstandingPaymentsReport";
import TrainingReport from "./components/admin/pages/reports/TrainingReport";
import MyCertifications from "./components/MyCertifications/MyCertifications";

import RegistrationView from "./components/admin/events/Registration";
import GetAttendees from "./components/admin/events/GetAttendees";
import AttendeeEditForm from "./components/admin/forms/AttendeeEditForm";
import RegistrationForm from "./components/admin/forms/RegistrationForm";
//import AddRegistrationForm from "./components/admin/forms/AddRegistrationForm";
import OptionalCosts from "./components/admin/events/OptionalCosts";
import Status from "./components/admin/events/Status";
import MyOrders from "./components/profile/MyOrders";
import MyReserved from "./components/MyReserved/MyReserved";
import TeamLeaderView from "./components/MyReserved/TeamLeaderView";
import EventInvoices from "./components/EventInvoices/EventInvoices";
import MakePayment from "./components/MakePayment/MakePayment";

import AccountingCodes from "./components/admin/pages/AccountingCodes";
import Partnerships from "./components/admin/pages/Partnerships";
import UserAdminProfile from "./components/admin/forms/UserAdminProfile";

//unprotected routes
import EventCheckIn from "./components/EventRegistration/EventCheckIn";
import EventsAndOpportunities from "./pages/EventsAndOpportunities/EventsAndOpportunities";
import Register from "./components/EventRegistration/Register";
import EventDetails from "./components/EventDetails";
import ThankYouPage from "./components/EventRegistration/ThankYouPage";
import ProfileContainer from "./components/profile/ProfileContainer";
import Login from "./pages/Login/Login";
import CreateAccount from "./pages/CreateAccount/CreateAccount";
import ActivateAccount from "./pages/ActivateAccount/ActivateAccount";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ConfirmEmailChange from "./pages/ConfirmEmailChange/ConfirmEmailChange";
import {
  NotFound,
  NotAuthorized,
  NoResults,
  RegistrationThanks,
} from "./components/Generic";
import VerifyUser from "./pages/VerifyUser/VerifyUser";

//import Profile from "./../Client/Pages/Profile/Profile"

import Layout from "./components/Layout";
import OrderPayment from "./components/MakePayment/OrderPayment";

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/createaccount" element={<CreateAccount />} />
    <Route path="/activate-account" element={<ActivateAccount />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/confirm-email-change" element={<ConfirmEmailChange />} />
    <Route element={<Layout />}>
      {/* PUBLIC ROUTES */}
      {/*<Route path='/admin/login' element={<Login/>} />*/}
      {/* <Route path="/" element={<EventsAndOpportunities />} />
      <Route path="/events" element={<EventsAndOpportunities />} />
      <Route path="/events/details/:eventid" element={<EventDetails />} /> */}

      <Route path="/verify" element={<VerifyUser />} />
      <Route path="/unauthorized" element={<NotAuthorized />} />

      {/* <Route element={<PersistLogin />}> */}

        {/* ── Role ID legend ──────────────────────────────────────────────
             32/8  = BOM Super Administrator  (full access)
             33/32 = BOM Administrator        (no Payments, no Settings)
             285/33 = BOM Finance              (Events, Users, Payments, Reporting)
             38/24 = BOM Check-In Staff       (Check-In only)
             35 = BOM Event Administrator  (Events, Users, Certifications, Check-In, Reporting)
             18/38 = BOM Event Coordinator    (Events, Users)
           ──────────────────────────────────────────────────────────────── */}

        {/* Home — every admin role (Dashboard filters tiles by role) */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 285, 38, 35, 18]} />}>
          <Route path="/admin" element={<Dashboard />} />
        </Route>

        {/* Users — all except Check-In Staff */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 285, 35, 18]} />}>
          <Route path="/admin/users" element={<Users />} />
          <Route path="/admin/users/create" element={<AddUser />} />
          <Route path="/admin/users/edit/:userid" element={<CreateEditUser />} />
          <Route path="/admin/users/edit/profile/:userid" element={<UserAdminProfile/>}/>
        </Route>

        {/* Payments — Super Admin + Finance */}
        <Route element={<RequireAuth allowedRoles={[32, 285]} />}>
          <Route path="/admin/finances" element={<Finances />} />
          <Route path="/admin/finances/:orderId" element={<OrderDetail />} />
        </Route>

        {/* Roles — Super Admin + Administrator */}
        <Route element={<RequireAuth allowedRoles={[32, 33]} />}>
          <Route path="/admin/roles" element={<Roles />} />
          <Route path="/admin/roles/new" element={<RoleEdit />} />
          <Route path="/admin/roles/edit/:roleid" element={<RoleEdit />} />
        </Route>

        {/* Certifications — Super Admin + Administrator + Event Admin */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 35]} />}>
          <Route path="/admin/certifications" element={<Certifications />} />
          <Route path="/admin/certifications/new" element={<CertificationEdit />} />
          <Route path="/admin/certifications/edit/:certTypeId" element={<CertificationEdit />} />
        </Route>

        {/* Reporting — Super Admin + Administrator + Finance + Event Admin */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 285, 35]} />}>
          <Route path="/admin/reporting" element={<Reporting />} />
          <Route path="/admin/reporting/add" element={<AddReport />} />
          <Route path="/admin/reporting/run/:reportType" element={<DynamicReportRunner />} />
          <Route path="/admin/reporting/revenue" element={<RevenueReport />} />
          <Route path="/admin/reporting/outstanding" element={<OutstandingPaymentsReport />} />
          <Route path="/admin/reporting/training" element={<TrainingReport />} />
        </Route>

        {/* Settings — Super Admin only */}
        <Route element={<RequireAuth allowedRoles={[32]} />}>
          <Route path="/admin/settings" element={<Settings />} />
        </Route>

        {/* Check-In — Super Admin + Administrator + Check-In Staff + Event Admin */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 38, 35]} />}>
          <Route path="/admin/checkin" element={<EventCheckin />} />
          <Route path="/admin/checkin/:eventId" element={<EventCheckinDetail />} />
          <Route path="/admin/checkin/:eventId/:userId" element={<UserCheckin />} />
        </Route>

        {/* Events — Super Admin + Administrator + Finance + Event Admin + Event Coordinator */}
        <Route element={<RequireAuth allowedRoles={[32, 33, 285, 35, 38, 18]} />}>
          <Route path="/admin/events" element={<Events />} />
          <Route path="/admin/events/create" element={<EventsForm />} />
          <Route path="/admin/events/:eventid" element={<EventsForm />} />
          <Route path="/admin/events/general/:eventid" element={<EventsForm />} />
          <Route path="/admin/events/attendees/:eventid" element={<GetAttendees />} />
          <Route path="/admin/events/attendeeedit/:attendeeid" element={<AttendeeEditForm />} />
          <Route path="/admin/events/registration/:eventid" element={<RegistrationView />} />
          <Route path="/admin/events/registration/add/:eventid" element={<RegistrationForm />} />
          <Route path="/admin/events/registration/:eventid/:registrationid" element={<RegistrationForm />} />
          <Route path="/admin/events/optionalcosts/:eventid" element={<OptionalCosts />} />
          <Route path="/admin/events/status/:eventid" element={<Status />} />
          <Route path="/admin/partnerships/:partnership" element={Outlet} />
          <Route path="/admin/partnerships" element={<Partnerships />} />
          <Route path="/admin/accountingcodes/:accountingcode" element={Outlet} />
          <Route path="/admin/accountingcodes" element={<AccountingCodes />} />
        </Route>

        {/* PRIVATE ROUTES, ONLY SIGNED IN USERS */}
          <Route element={<RequireAuth allowedRoles={[]} />}>
          <Route path="/" element={<Navigate to="/events" replace />} />
          <Route path="/events" element={<EventsAndOpportunities />} />
          <Route path="/events/details/:eventid" element={<EventDetails />} />
          <Route path="/profile" element={<ProfileContainer />} />
          <Route path="/myreserved" element={<MyReserved />} />
          <Route path="/team-view/:eventId/:teamName" element={<TeamLeaderView />} />
          <Route path="/invoices/:attendeeId" element={<EventInvoices />} />
          <Route path="/makepayment/order/:orderId" element={<OrderPayment/>}/>
          <Route path="/makepayment/:eventId/:userId" element={<MakePayment />} />
          <Route path="/makepayment/:attendeeId" element={<MakePayment />} />
          <Route
            path="/events/register/:eventid"
            element={<Register quantity />}
          />
          <Route
            path="/events/register/:eventid/thanks"
            element={<RegistrationThanks />}
          />
          <Route path="/events/thanks" element={<ThankYouPage/>} />
          <Route path="/myorders" element={<MyOrders />} />
          <Route path="/mycertifications" element={<MyCertifications />} />
          <Route path="/checkin" element={<EventCheckIn />} />
        </Route>
      {/* </Route> */}

      {/* CATCH ALL */}
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;


